import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid,
} from '@mui/material';
import BatteryFullIcon from '@mui/icons-material/BatteryFull';
import BatteryAlertIcon from '@mui/icons-material/BatteryAlert';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const SmartLockCard = ({ lock }) => {
    const getBatteryIcon = (level) => level > 0.2 ? BatteryFullIcon : BatteryAlertIcon;
    const getBatteryColor = (level) => level > 0.2 ? 'success.main' : 'warning.main';
    const getOnlineColor = (online) => online ? 'success.main' : 'error.main';

    return (
        <Card sx={{ mb: 2, border: `1px solid ${lock.isLocked ? '#4caf50' : '#ff9800'}` }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                            {lock.deviceName || 'Smart Lock'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {lock.manufacturer}
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="body2" color="text.secondary">
                            {lock.isLocked ? 'Locked' : 'Unlocked'}
                        </Typography>
                    </Box>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <FiberManualRecordIcon sx={{ fontSize: 12, mr: 1, color: getOnlineColor(lock.online) }} />
                            <Typography variant="body2" color="text.secondary">
                                Status: {lock.online ? 'Online' : 'Offline'}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {React.createElement(getBatteryIcon(lock.batteryLevel  || 0), {
                                sx: { fontSize: 16, mr: 1, color: getBatteryColor(lock.batteryLevel  || 0) }
                            })}
                            <Typography variant="body2" color="text.secondary">
                                Battery: {Math.round((lock.batteryLevel  || 0) * 100)}%
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {lock.manufacturer && (
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                Manufacturer: {lock.manufacturer}
                            </Typography>
                        )}
                        {lock.deviceType && (
                            <Typography variant="body2" color="text.secondary">
                                Type: {lock.deviceType.replace('_', ' ')}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SmartLockCard;
